import { Box } from '@mui/material';
import { ChangeEvent, useRef, useState } from 'react';
import { Button } from '../button';
import { Typography } from '../typography';
import { t } from 'i18next';

interface Props {
  onFileSelect?: (file: File) => void;
  label: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  onlyButton?: boolean;
  loading?: boolean;
  acceptFiles?: string;
}

export const FileUpload = ({ onFileSelect, label, color, onlyButton, loading, acceptFiles }: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState<string>('');

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      onFileSelect?.(file); // callback al parent
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <Box display="flex" alignItems="center" gap={2} height={'100%'}>
      <input type="file" accept={acceptFiles} ref={inputRef} style={{ display: 'none' }} onChange={handleFileChange} />
      <Button loading={loading} color={color} variant="contained" onClick={handleClick}>
        {label}
      </Button>
      {!onlyButton && <Typography color="textSecondary">{fileName || t('info.noFileSelected')}</Typography>}
    </Box>
  );
};
